import { forwardRef } from 'react';

import type { IPulseCircleProps } from './IPulseCircleProps';
import PulseCircleStyles from './pulse-circle.module.css';

const PulseCircle = forwardRef<HTMLDivElement, IPulseCircleProps>(
  (props, ref) => {
    return (
      <div
        className={PulseCircleStyles['pulsating-circle']}
        {...props}
        ref={ref}
      />
    );
  }
);

PulseCircle.displayName = 'PulseCircle';

export default PulseCircle;
